import { Pagination as MuiPagination, PaginationItem } from '@material-ui/lab';
import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';

const Pagination = ({ className, onChange, page, pageCount, totalCount }) => {
  const {
    css,
    cx,
    classes,
    theme: { spacing },
  } = useStyles(styles);

  const count = Math.ceil(totalCount / pageCount);

  return count > 1 ? (
    <div className={classes.pagination}>
      <MuiPagination
        count={count}
        onChange={(_, newPage) => onChange(newPage)}
        page={page}
        renderItem={item => {
          if (item.type === 'next' || item.type === 'previous')
            return <PaginationItem {...item} className={classes.paginationItem} />
        }}
      />
    </div>
  ) : null;
};

const styles = ({ fontSizes, spacing }) => ({
  pagination: {
    minWidth: '78px',
    display: 'flex',
    justifyContent: 'center',
    color: '#5A6DA1 !important',
    '.MuiPaginationItem-page.Mui-disabled': {
      opacity: 1,
      background: '#F3F7FF !important',
      color: '#C0D9FF !important'
    },
    '.MuiPaginationItem-root': {
      color: '#5A6DA1 !important',
    }
  },
  paginationItem: {
    border: '1px solid #C0D9FF',
    background: '#F3F7FF',
    color: '#152652',
    '&:hover': {
      border: '1px solid #C0D9FF',
      background: '#F3F7FF',
      color: '#5A6DA1',
      filter: 'brightness(0.95)'
    },
  }
})

Pagination.propTypes = {
  pageCount: PropTypes.number,
  totalCount: PropTypes.number,
  onChange: PropTypes.func,
  page: PropTypes.number,
  className: PropTypes.string,
};

export default Pagination;
